import React, { useEffect, useRef, useState, useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import RadialFill from '../../../../assets/images/Radial Fill.png'
import RadialNull from '../../../../assets/images/Radial Null.png'

const StopPaymentDurationModal = ({ isOpen, onClose, onDateSelect }) => {
  const { t } = useTranslation();
  const modalRef = useRef(null);

  const [optionsList, setOptionsList] = useState([]);
  const [selectedOption, setSelectedOption] = useState({});


  const calculateFutureDateObject = (months) => {
    const currentDate = new Date();
    const futureDate = new Date(currentDate);
    futureDate.setMonth(futureDate.getMonth() + months);
    return futureDate;
  };

  useEffect(() => {
    const calculateFutureDate = (months) => {
      const currentDate = new Date();
      const futureDate = new Date(currentDate);
      futureDate.setMonth(futureDate.getMonth() + months);

      const options = { year: 'numeric', month: 'long', day: 'numeric' };
      return futureDate.toLocaleDateString('en-US', options);
    };

    const durationOptions = {
      Response: [
        { type: '3_months', months: 3, displayText: `3 months - ${calculateFutureDate(3)}` },
        { type: '6_months', months: 6, displayText: `6 months - ${calculateFutureDate(6)}` },
        { type: '13_months', months: 13, displayText: `13 months - ${calculateFutureDate(13)}` },
        { type: '60_months', months: 60, displayText: `60 months - ${calculateFutureDate(60)}` },
      ]
    };

    const durationList = durationOptions.Response;
    setOptionsList(durationList);
  }, []);

  const onOptionSelect = (option) => {
    setSelectedOption(option);
  };

  useEffect(() => {
    const handleKeyDown = (event) => {
      if (event.key === 'Escape' && isOpen) {
        onClose();
      }
    };

    if (isOpen) {
      document.addEventListener('keydown', handleKeyDown);
      if (modalRef.current) {
        modalRef.current.focus();
      }
    }

    return () => {
      document.removeEventListener('keydown', handleKeyDown);
    };
  }, [isOpen, onClose]);

 const handleApplyClick = () => {
    if (!onDateSelect) return;
    const duration = selectedOption?.months ?? 3;
    const selectedDate = selectedOption?.months
      ? calculateFutureDateObject(selectedOption.months)
      : new Date();
    onDateSelect({ selectedDate, duration });
  };


  if (!isOpen) return null;

  return (
    <div
      className="fixed top-0 left-0 w-full h-full flex justify-center items-center bg-[var(--modalcard-overlay)]"
      style={{ zIndex: 200 }}
    >
      <div
        ref={modalRef}
        className="bg-[#FEFAEE] rounded-tr-[4rem] rounded-bl-[4rem] md:w-[600px] sm:w-[466px] w-[90%] mx-auto shadow-lg z-50 overflow-y-auto max-h-[90vh]"
        tabIndex="-1"
        role="dialog"
        aria-modal="true"
        aria-labelledby="stop-payment-title"
        aria-describedby="stop-payment-description"
      >
        <div className="modal-content text-left">
          <div className="flex justify-center items-center sm:my-[60px] md:mt-[80px] mt-[50px] mb-[50px]">
            <div className="md:w-[430px] sm:w-[294px] w-[280px]">
              <div className="relative">
                {/* Title */}
                <h1 className="font-serif-pro text-[#262B3A] font-normal md:text-[32px] sm:text-[28px] text-[25px] md:leading-[38px] leading-[32px] mb-4">
                  {t('EDIT_STOP_PAYMENT_DURATION')}
                </h1>

                {/* Subtitle */}
                <p className="font-hanken-grotesk text-[#262B3A] md:text-[16px] text-[14px] leading-[24px] font-medium mb-6">
                  {t('CHOOSE_NEW_STOP_PAYMENT_END_DATE')}
                </p>

                {/* Duration Label */}
                <p className="font-hanken-grotesk text-[#9CA3AF] text-[12px] font-bold uppercase mb-4 tracking-[2px]">
                  {t('duration')}
                </p>

                {/* Duration Options */}
                <div className="flex flex-col w-full">
                  {optionsList.map((option) => {
                    const textParts = option.displayText.split(' - ');
                    const boldPart = textParts[0];
                    const regularPart = textParts[1] ? ` - ${textParts[1]}` : '';

                    return (
                      <div
                        key={option.type}
                        className="flex flex-row items-center py-3 cursor-pointer"
                        onClick={() => onOptionSelect(option)}
                      >
                        <img
                          src={selectedOption.displayText === option.displayText ? RadialFill : RadialNull}
                          alt="Radio"
                          className="cursor-pointer h-[20px] w-[20px]"
                        />
                        <p className="font-hanken-grotesk text-[#262B3A] md:text-[16px] text-[14px] leading-[24px] ml-4">
                          <span className="font-semibold">{boldPart}</span>
                          <span className="font-normal">{regularPart}</span>
                        </p>
                      </div>
                    );
                  })}
                </div>

                {/* Buttons */}
                <div className="mt-10">
                  <button
                    type="button"
                    className="w-full h-[55px] font-hanken-grotesk font-bold text-[14px] leading-[16px] bg-[#2965FB] text-white border-[#2965FB] border-[2.5px]"
                    onClick={handleApplyClick}
                    aria-label={t('apply_duration_selection')}
                  >
                    {t('continue')}
                  </button>

                  <button
                    type="button"
                    className="w-full h-[55px] mt-4 font-hanken-grotesk font-bold text-[14px] leading-[16px] border-[var(--modal-btn-color)] border-[2.5px] text-[var(--modal-btn-color)]"
                    onClick={onClose}
                    aria-label={t('cancel_and_close')}
                  >
                    {t('Cancel')}
                  </button>
                </div>

                {/* Close Button */}
                <span className="absolute top-[-30px] right-0">
                  <button 
                    className="modal-close text-gray-500 hover:text-gray-800 cursor-pointer"
                    onClick={onClose}
                  >
                    <svg 
                      xmlns="http://www.w3.org/2000/svg"
                      className="h-[1rem] w-[1rem] opacity-[60%]"
                      fill="none"
                      viewBox="0 0 24 24"
                      stroke="currentColor"
                    >
                      <path 
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth={2} 
                        d="M6 18L18 6M6 6l12 12" 
                      />
                    </svg>
                  </button>
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default StopPaymentDurationModal;